<template>
  <span>{{ formatted }}</span>
</template>

<script>
// datetime component
// Render a moment.js instance as a human-readable string in a span element

import dates from '../../services/dates'

export default {
  props: ['value'],
  computed: {
    formatted: function () {
      // pass config.lang as dummy arg to make it reactive
      return dates.longFormat(this.value, this.$i18n.locale)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Datetime.vue?1ac777e5